import ReactOnRails from 'react-on-rails/client';
import HelloWorld from '../../src/HelloWorld/ror_components/HelloWorld.client.jsx';

ReactOnRails.register({HelloWorld});